/**
 *
 * PassControlSelection
 *
 */

import React, { memo, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// styles
import './style.scss';

// antd component
//import { Card } from 'antd';

// icons
import CustomIcons from 'components/CustomIcons';
// utils
import { getExcusedAbsenceStd } from 'utils/helpers/helper.generateData';
import { getObjId } from 'utils/helpers/helper.general';

function PassControlSelection({
  // states
  formData,
  course,
  currentStep,
  // actoins
  goToStep,
  changeControlType,
  result,
  // default props
  className,
}) {
  const childClassNames = classNames('pass-control-selection', className);

  const checkAllStd = useCallback(() => {
    changeControlType('all');
    const absStd = getExcusedAbsenceStd(
      course?.students,
      formData?.date,
      course,
    );
    const allStd = course?.students.filter(
      std => !absStd.find(missStd => getObjId(missStd) == getObjId(std)),
    );
    result({
      missing_students: absStd || [],
      students: allStd || [],
    });
    goToStep(currentStep + 2);
  }, [currentStep, course,  course?.students, formData?.date, changeControlType, result]);

  const checkAbsentStd = useCallback(() => {
    changeControlType('check-absent');
    goToStep(currentStep + 1);
  }, [currentStep]);

  const checkPresentStd = useCallback(() => {
    changeControlType('check-present');
    goToStep(currentStep + 1);
  }, [currentStep]);

  const renderCheckAll = useMemo(() => (
    <div className="presences-actions" onClick={checkAllStd}>
      <span className="presences-actions-icon">
        <CustomIcons type="absence-checked" />
      </span>
      <span className="presences-actions-title">
        Tous les étudiants sont présents ou excusés
      </span>
      <span className="presences-actions-arrow">
        <CustomIcons type="arrow-right" />
      </span>
    </div>
  ), [checkAllStd]);
  const renderCheckAbsent = useMemo(() => (
    <div className="presences-actions" onClick={checkAbsentStd}>
      <span className="presences-actions-icon">
        <CustomIcons type="check-absent" />
      </span>
      <span className="presences-actions-title">
        Cocher les étudiants absents
      </span>
      <span className="presences-actions-arrow">
        <CustomIcons type="arrow-right" />
      </span>
    </div>
  ), [checkAbsentStd]);
  const renderCheckPresent = useMemo(() => (
    <div className="presences-actions" onClick={checkPresentStd}>
      <span className="presences-actions-icon">
        <CustomIcons type="check-present" />
      </span>
      <span className="presences-actions-title">
        Cocher les étudiants présents
      </span>
      <span className="presences-actions-arrow">
        <CustomIcons type="arrow-right" />
      </span>
    </div>
  ), [checkPresentStd]);

  return (
    <div className={childClassNames}>
      {renderCheckAll}
      {renderCheckAbsent}
      {renderCheckPresent}
    </div>
  );
}

PassControlSelection.defaultProps = {};
PassControlSelection.propTypes = {
  formData: PropTypes.oneOfType([
    PropTypes.object.isRequired,
    PropTypes.bool.isRequired,
  ]),
};

export default memo(PassControlSelection);
